var map = {
	"./blog_grid_1.jpg": 457,
	"./blog_grid_2.jpg": 458,
	"./blog_grid_3.jpg": 459,
	"./blog_grid_4.jpg": 460,
	"./blog_grid_5.jpg": 461,
	"./blog_grid_6.jpg": 462,
	"./blog_grid_7.jpg": 463,
	"./blog_grid_8.jpg": 464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;